import { Button } from "@backslashbuild/pp-ui";
import React from "react";

export default function UnlockButton({ onClick }) {
  return (
    <Button
      large
      onClick={() => {
        onClick();
      }}
    >
      Unlock
    </Button>
  );
}
